export default "__VITE_ASSET__p1JgHjjg__"